module.exports = __webpack_public_path__ + "img/map_focus.c4d00b1e.png";